<template>
  <div class="ListView" style="margin-bottom: 10px">
    <el-row :gutter="20">
      <el-col :span="6" v-if="showLeftTree">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <el-button type="text" style="float:left" @click="handleReset">{{$t('buttons.showAll')}}</el-button>
          </div>
          <el-scrollbar>
            <div class="warp" style="height:508px">
              <el-tree
                ref="filterTree"
                :props="props"
                node-key='id'
                :load="handleLoadNode"
                highlight-current
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                lazy>
              </el-tree>
            </div>
          </el-scrollbar>
        </el-card>
      </el-col>
      <el-col :span="showLeftTree?18:24">
        <el-row>
          <el-col :span="12">
            <el-button type="primary" @click="ReturnSelectedData" icon="el-icon-check">{{$t('buttons.confirm')}}</el-button>
            <el-button type="danger" @click="CleanFillRange">
              <svg-icon icon-class="clear"></svg-icon>
              {{$t('buttons.clear')}}
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" justify="end">
              <SearchBar
                v-model="queryStr"
                :header="listHeader"
                @handleSearch="handleSearch"/>
              <!-- <el-input v-model="queryStr"  @keyup.enter.native="handleSearch"></el-input>
              <el-button type="primary" @click="handleSearch" style="margin-left:14px" icon="el-icon-search">{{$t('buttons.search')}}</el-button> -->
            </el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <div>
            <el-table key="dataTable"
              ref="tableTemplate"
              class="listTable"
              v-loading="tableLoading"
              stripe
              border
              size="mini"
              highlight-current-row
              :data="listViewData"
              :height="500"
              @row-click="listViewTableRowClick"
              @select="updateSelection"
              @select-all="updateSelection"
              @row-dblclick="rowDblClick"
              @sort-change="sortChange">
              <el-table-column
                key="selection"
                class-name="selection-Column"
                v-if="!listViewInfo.single"
                fixed="left"
                width="55"
                type="selection">
              </el-table-column>
              <el-table-column
                key="radio"
                v-if="listViewInfo.single"
                fixed="left"
                class-name="radio-Column"
                :label="$t('listview.pick')"
                align="center"
                width="55">
                <template slot-scope="scope">
                  <el-radio v-model="singleSelection" :label="scope.$index"></el-radio>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(column,index) in tableHeader"
                v-if="!column.hide"
                sortable="custom"
                :prop="column.id"
                :label="column.name"
                :key="index"
                :min-width="columnWidth(column)"               
                show-overflow-tooltip>
                <!--  sortable="custom" -->
                <template slot="header" slot-scope="scope">
                  <!-- <el-button type="text" v-if="searchList[column.id]">{{column.name}}</el-button> -->
                  <span class="label">{{column.name}}</span> 
                  <!-- <div class="el-input el-input--small el-input--suffix">
                    <input 
                      class="el-input__inner" 
                      size="mini"
                      v-model="searchList[column.id]"
                      :placeholder="column.name"
                      @click.stop.prevent="()=>{}"
                      @keyup.enter="handleSearchChange"/>
                      <span v-if="searchList[column.id]" class="el-input__suffix" @click.stop.prevent="handleSearchChange">
                        <span class="el-input__suffix-inner"><i class="el-input__icon el-icon-search"></i>
                        </span>
                      </span> 
                      <span style="right:25px" v-if="searchList[column.id]" class="el-input__suffix" @click.stop.prevent="handleClear(column.id)">
                        <span class="el-input__suffix-inner"><i class="el-input__icon el-icon-error"></i>
                        </span>
                      </span>
                    </div>        -->
                </template>
                <template slot-scope="scope">
                  {{SetListViewData(scope.row[column.id])}}
                </template>
              </el-table-column>
            </el-table>
            <el-row style="margin-top:10px" type="flex" justify="end">
              <el-col :span="3">
                <div>
                  <el-badge :value="selectionTableData.length" v-if="!listViewInfo.single" class="item">
                    <el-button size="small" @click="selectionVisiable=true">{{$t('listview.viewSelected')}}</el-button>
                  </el-badge>
                </div>
              </el-col>
              <el-col :span="21">
                <el-pagination
                  style="text-align:right;margin-right:-20px"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageQuery.pageIndex"
                  :page-sizes="[30, 50, 100]"
                  :page-size="pageQuery.pageSize"
                  layout="total, prev, pager, next, sizes"
                  :total="pageTotal">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-row>
      </el-col>
    </el-row>    
    <el-dialog
      id="selection-table"
      key="selectionTable"
      :title="$t('listview.selected')"
      :visible.sync="selectionVisiable"
      append-to-body
      v-el-drag-dialog>
      <el-row>
        <el-col>
          <el-button type="primary" @click="selectionVisiable=false" style="margin-right:9px">{{$t('buttons.confirm')}}</el-button>
          <el-popover v-model="deleteAllVisiable" width="200">
            <p>{{$t('listview.isClearAll')}}</p>
            <div style="text-align: right; margin: 0">
              <el-button type="danger" size="mini" style="margin-top: 10px" @click="ClearSelection">{{$t('buttons.confirm')}}</el-button>
              <el-button type="primary" size="mini" style="margin-top: 10px" @click="deleteAllVisiable=false">{{$t('buttons.cancel')}}</el-button>
            </div>
            <el-button type="danger" slot="reference">{{$t('listview.deleteAll')}}</el-button>
          </el-popover>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px;margin-bottom: 10px">
        <div>
          <el-table
            ref="selectionTableTemplate"
            v-loading="selectionTableLoading"
            stripe
            border
            highlight-current-row
            :data="selectionTableData"
            :height="500"
            style="width: 100%">
            <el-table-column
              fixed="left"
              :label="$t('table.toolBar')"
              width="55"
              align="center"
              class-name="delete-Column">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="DeleteSelection(scope.$index, selectionTableData)">
                  <svg-icon class="delete-icon" icon-class="delete" style="width:12px"/>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(column,index) in tableHeader"
              v-if="!column.hide"
              sortable="custom"
              :prop="column.id"
              :label="column.name"
              :min-width="100"
              :key="index"
              show-overflow-tooltip/>
          </el-table>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import SearchBar from '@/components/SearchBarAd'
import { getListSpecsOutput, getDataSpecListClassification } from '@/api/dataSpec.js'
export default {
  name: 'ListView',
  components: {
    SearchBar
  },
  data() {
    return {
      listHeader: [],
      searchList: {},
      classIficationListParams: {
        level: 1,
        classFilters: '',
        param: this.listViewInfo.params,
        fieldId: this.listViewInfo.fieldId
      },
      nodePathStrArr: '',
      props: {
        label: 'name',
        isLeaf: 'leaf'
      },
      showLeftTree: true,
      classFilter: '',
      // 搜索框搜索内容
      queryStr: '',
      pageTotal: 0,
      pageQuery: {
        pageIndex: 1,
        pageSize: 30,
        paperCount: 3,
        sort: '',
        Filters: ''
      },
      listViewData: [],
      tableLoading: false,
      param: {
        classFilters: [],
        Filters: '',
        Filter: ''
      },
      tableHeader: [],
      listViewColumnInfo: {},
      selectionVisiable: false,
      selectionTableLoading: false,
      selectionTableData: [],
      deleteAllVisiable: false,
      singleSelection: null
    }
  },
  props: {
    listViewInfo: Object,
    cache: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleSearch(advance, val) {
      this.$set(this.pageQuery, 'Filters', '')
      this.$set(this.param, 'Filters', '')
      this.pageQuery.pageIndex = 1
      if (advance) {
        this.pageQuery.Filters = val
      }
      this.fetchTableData()
    },
    sortChange(val) {
      const prop = val.prop !== null ? val.prop.split('-')[1] || val.prop : null
      const sort = val.order !== null ? `${prop}|${val.order.substring(0, val.order.length - 6)}` : ''
      this.pageQuery.sort = sort
      this.fetchTableData()
    },
    handleSearchChange() {
      this.param.Filter = ''
      let filters = Object.keys(this.searchList).map((v) => {
        return {
          id: +v,
          'op': '',
          'v': this.searchList[v],
          t: this.listHeader.find(l => l.column === v).baseType
        }
      })
      filters = filters.filter(f => f.v !== '')
      this.pageQuery.Filters = JSON.stringify(filters)
      this.fetchTableData()
    },
    handleClear(id) {
      this.$set(this.searchList, id, '')
      this.handleSearchChange()
    },
    handleReset() {
      this.$refs.filterTree.setCurrentKey(null)
      this.param.classFilters = ''
      this.fetchTableData()
    },
    // 分级预览
    // 获取点击节点路径数组
    getParentPathStr(node) {
      let str = ''
      str = {id: node.data.fieldId, op: 'equals', v: node.data.name, t: node.data.type} // `${node.data.fieldId}_equals|${node.data.name}`
      this.nodePathStrArr.unshift(str)
      if (node.parent.data) {
        this.getParentPathStr(node.parent)
      }
    },
    // 分级树点击
    handleNodeClick(data, node, el) {
      this.previewLoading = true
      this.nodePathStrArr = []
      this.getParentPathStr(node)
      this.param.classFilters = JSON.stringify(this.nodePathStrArr)
      this.fetchTableData()
    },
    // 获取分级预览
    getDataSpecListClassification(getNode) {
      return new Promise(resolve => {
        var data = {}
        if (this.listViewInfo.unique && this.listViewInfo.unique.length) {
          data.unique = this.listViewInfo.unique
        }
        getDataSpecListClassification(this.listViewInfo.specId, this.classIficationListParams, data).then(response => {
          getNode(response.data)
          resolve(response.data)
        })
      })
    },
    // 懒加载树
    handleLoadNode(node, resolve) {
      if (node.level === 0) {
        this.getDataSpecListClassification(resolve).then(data => {
          this.showLeftTree = data.length !== 0
        })
      }
      if (node.level >= 1) {
        this.nodePathStrArr = []
        this.getParentPathStr(node)
        this.classIficationListParams.level = node.level + 1
        this.classIficationListParams.classFilters = JSON.stringify(this.nodePathStrArr)
        this.getDataSpecListClassification(resolve)
      }
    },
    GetListViewData() {
      this.tableLoading = true
      this.param.id = this.listViewInfo.specId
      this.param.param = this.listViewInfo.params
      this.listViewColumnInfo = this.listViewInfo.columns
      this.listViewInfo.resultOneRow = this.listViewInfo.oneRow
      this.tableHeader = []
      this.searchList = {}
      for (var i = 0; i < this.listViewColumnInfo.length; i++) {
        this.$set(this.searchList, this.listViewColumnInfo[i].id, '')
        this.tableHeader.push({
          name: this.listViewColumnInfo[i].name,
          id: this.listViewColumnInfo[i].id.toString(),
          hide: this.listViewColumnInfo[i].hide,
          seq: this.listViewColumnInfo[i].seq,
          type: this.listViewColumnInfo[i].baseType
        })
      }
      this.QueryListData()
    },
    handleSizeChange(val) {
      this.pageQuery.pageSize = val
      this.fetchTableData()
    },
    handleCurrentChange(val) {
      this.pageQuery.pageIndex = val
      this.fetchTableData()
    },
    QueryListData() {
      this.frozenSelection()
      this.param.fieldId = this.listViewInfo.fieldId
      this.param.Filter = this.queryStr
      this.param.Filters = this.pageQuery.Filters
      this.param.PageSize = this.pageQuery.pageSize
      this.param.PageIndex = this.pageQuery.pageIndex
      this.param.sort = this.pageQuery.sort
      var data = {}
      if (this.listViewInfo.unique && this.listViewInfo.unique.length) {
        data.unique = this.listViewInfo.unique
      }
      var cacheable = this.listViewInfo.cache
      if (cacheable) {
        if (this.cache[this.param.id]) {
          console.time('查找缓存')
          var cacheValue = this.cache[this.param.id].find(item => item.param === JSON.stringify(this.param) && item.data === JSON.stringify(data))
          if (cacheValue) {
            console.timeEnd('查找缓存')
            this.singleSelection = null
            this.listViewData = cacheValue.value
            for (var dataIndex in this.listViewData) {
              this.listViewData[dataIndex].select = false
            }
            this.pageTotal = cacheValue.total
            setTimeout(() => { this.tableLoading = false }, 200)
            return
          }
        } else {
          this.cache[this.param.id] = []
        }
        setTimeout(() => {
          this.$refs.tableTemplate.doLayout()
        }, 1000)
      }
      getListSpecsOutput(this.param, data).then(response => {
        if (response.status === 200) {
          this.singleSelection = null
          this.listViewData = response.data.data
          if (this.listHeader.length === 0) {
            this.listHeader = response.data.header
            this.listHeader.forEach(a => {
              this.$set(a, 'filter', a.filter || (a.baseType === 3 ? [] : ''))
            })
          }

          for (var dataIndex in this.listViewData) {
            this.listViewData[dataIndex].select = false
          }
          // debugger
          this.pageTotal = response.data.total
          if (cacheable) {
            this.cache[this.param.id].push({
              param: JSON.stringify(this.param),
              data: JSON.stringify(data),
              value: response.data.data,
              total: this.pageTotal
            })
          }
          setTimeout(() => {
            this.tableLoading = false
            this.$refs.tableTemplate.doLayout()
          }, 200)
        }
      })
    },
    columnWidth(row) {
      const sizeof = function(str, charset) {
        let total = 0
        let charCode
        let i
        let len
        charset = charset ? charset.toLowerCase() : ''
        if (charset === 'utf-16' || charset === 'utf16') {
          for (i = 0, len = str.length; i < len; i++) {
            charCode = str.charCodeAt(i)
            if (charCode <= 0xffff) {
              total += 2
            } else {
              total += 4
            }
          }
        } else {
          for (i = 0, len = str.length; i < len; i++) {
            charCode = str.charCodeAt(i)
            if (charCode <= 0x007f) {
              total += 1
            } else if (charCode <= 0x07ff) {
              total += 2
            } else if (charCode <= 0xffff) {
              total += 3
            } else {
              total += 4
            }
          }
        }
        return total
      }
      var colInfo = this.tableHeader.find(header => header.id === row.id)
      if (colInfo) {
        // debugger
        if (colInfo.baseType === 4) {
          return '120'
        } else {
          const column = this.listViewData.map(t => {
            return t[colInfo.id] ? sizeof(t[colInfo.id], 'utf-8') : 0
          })
          column.sort(function(a, b) {
            return b - a
          })
          if (column[0]) {
            if ((column[0] * 4 + 22) < 110) {
              return 110
            } else if ((column[0] * 4 + 22) > 400) {
              return 400
            } else {
              return (column[0] * 4 + 22).toString()
            }
          } else {
            return '120'
          }
        }
      } else {
        return '120'
      }
    },
    fetchTableData() {
      return new Promise(resolve => {
        this.tableLoading = true
        this.QueryListData()
      })
    },
    listViewTableRowClick(row, column, cell, event) {
      if (this.listViewInfo.single) {
        this.$refs.tableTemplate.clearSelection()
        this.$refs.tableTemplate.toggleRowSelection(row, true)
        this.singleSelection = this.listViewData.indexOf(row)
      } else {
        this.$refs.tableTemplate.toggleRowSelection(row)
        this.updateSelection(row)
      }
    },
    rowDblClick(row) {
      this.listViewTableRowClick(row)
      this.ReturnSelectedData()
    },
    updateSelection() {
      var i
      for (i = this.selectionTableData.length - 1; i >= 0; i--) {
        if (!this.selectionTableData[i].frozen) {
          this.selectionTableData.splice(i, 1)
        }
      }
      var selectedRowsStr = []
      for (i = 0; i < this.selectionTableData.length; i++) {
        selectedRowsStr.push(JSON.stringify(this.selectionTableData[i]).replace(',"frozen":true', ''))
      }
      for (i = 0; i < this.$refs.tableTemplate.selection.length; i++) {
        if (selectedRowsStr.indexOf(JSON.stringify(this.$refs.tableTemplate.selection[i])) === -1) {
          this.selectionTableData.push(this.$refs.tableTemplate.selection[i])
        } else {
          // 勾选了相同内容时不给提示
        }
      }
    },
    frozenSelection() {
      for (var i = this.selectionTableData.length - 1; i >= 0; i--) {
        if (this.selectionTableData[i] === undefined) {
          this.selectionTableData.slice(i, 1)
          return
        }
        this.selectionTableData[i].frozen = true
      }
    },
    ShowSelection() {
      this.selectionVisiable = true
    },
    ClearSelection() {
      this.selectionTableData = []
      this.deleteAllVisiable = false
      this.selectionVisiable = false
      this.frozenSelection()
      this.$refs.tableTemplate.clearSelection()
    },
    DeleteSelection(index) {
      this.selectionTableData.splice(index, 1)
      this.frozenSelection()
      this.$refs.tableTemplate.clearSelection()
    },
    ReturnSelectedData() {
      if (this.listViewInfo.single) {
        this.selectionTableData = [this.$refs.tableTemplate.selection[this.$refs.tableTemplate.selection.length - 1]]
      }
      if (this.selectionTableData.length === 0) {
        this.$message({
          message: this.$t('listview.oneRecord'),
          type: 'warning'
        })
        return
      }
      if (this.selectionTableData[0] === undefined) {
        this.$message({
          message: this.$t('listview.validRecord'),
          type: 'warning'
        })
        return
      }
      this.$emit('WriteListSpecSelectedData', this.listViewInfo.fieldId,
        this.selectionTableData, this.listViewInfo)
    },
    CleanFillRange() {
      this.$emit('WriteListCleanFillRange', this.listViewInfo)
    },
    SetListViewData(data) {
      if (data && data instanceof String && data.indexOf('{"data":') === 0) {
        try {
          var obj = JSON.parse(data)
          if (obj.data.length) {
            return `(${obj.data.length})${obj.data[0].name}`
          } else {
            return ''
          }
        } catch (exception) {
          return data
        }
      } else if (isNaN(data) && !isNaN(Date.parse(data))) {
        return data ? data.replace(' 00:00:00', '') : ''
      } else {
        return data
      }
    }
  }
}
</script>

<style lang="scss">
.ListView{
  .search-bar{
    width: 100%;
    .el-input{
      width: calc(100% - 173px);
    }
    .WAdvancedSearch{
      width: calc(100% - 173px);
      float: left;
      .el-input{
        width: 100%;
      }
    }
  }
  
  .listTable{
    .cell{
      overflow: hidden;
      position: relative;
      .el-input{
        display: none;
        .el-input__suffix{
          cursor: pointer;
        }
      }
    }
    // .cell:hover{
    //   .el-button{
    //     display: none;
    //   }
    //   .label{
    //     display: none;
    //   }
    //   .caret-wrapper{
    //     display: block;
    //   }
    //   .el-input{
    //     display: block;
    //     width: calc(100%);
    //   }
    // }
    
    .el-input{
      float: right;
    }
  }
  .el-tree-node__content .el-tree-node__label{
    overflow: visible;
  }
  .el-card{
    .el-card__body{
      padding:0px 0px 0 0;
      .warp{
        padding: 10px 0px
      }
    }
    .el-card__header{
      padding: 0px 10px;
    }
  }
  .el-radio__label{
    display: none
  }
  .el-radio__input{
    margin-top: 4px
  }
  .selection-Column{
    text-align: center !important;
    .el-checkbox{
      margin-top: 3px;
      margin-bottom: -3px
    }
  }
  .radio-Column{
    text-align: center !important;
    .el-radio{
      margin-top: 2px;
      margin-bottom: -2px
    }
  }
}

</style>
